import { useLocation } from 'react-router-dom';
import './customhistory.scss'
import { ChevronRight } from 'lucide-react';
import { useEffect, useState } from 'react';

const CustomHistory=()=>{
    const location = useLocation();
    const [subPage,setSubPage]=useState('')
   

    useEffect(() => {
        const hash = location.hash; 
        const path = hash ? hash.replace(/^#/, '') : location.pathname; 
        const firstSegment = path.split('/').filter(Boolean)[0] || '';
        setSubPage(firstSegment);
        
        // eslint-disable-next-line
    }, [location.pathname, location.hash]);


    return ( <div className="customhistory">

        <div className='centerDiv'>
        <div className="category">Home</div>
        <div className="arr"><ChevronRight size={18}></ChevronRight></div>
        <div className="subcategory">{subPage}</div>
        </div>


    </div>)

}

export default CustomHistory;